import React from 'react';
import PropTypes from 'prop-types';

import MuiBox from '@material-ui/core/Box';

/**
 * Default Box component based on https://material-ui.com/components/box
 * @param {} props All possible props can be found in docs https://material-ui.com/components/box/#api
 */
export default function Box(props) {
  const { children, ...rest } = props;

  return <MuiBox {...rest}>{children}</MuiBox>;
}

Box.propTypes = {};

Box.defaultProps = {};
